import { Component, Fragment } from 'react';
import { Transition } from 'semantic-ui-react';
import { DEPRECATED_RouteComponentProps, DEPRECATED_withRouter } from 'components/lib/with-router';
import { LoginStore, LoginState } from '../../stores/login.store';
import { injectDependency } from '@servicetitan/react-ioc';
import { observer } from 'mobx-react';
import { Captcha, CaptchaStore } from 'components';
import classnames from 'classnames';
import Turnstile from 'react-turnstile';
import { Button, Headline, Form } from '@servicetitan/design-system';
import { PasswordInput } from '../../../components/password-input/password-input';
import { TurnstileSiteKey } from '../../../utils/config';

@observer
class LoginFormUnwrapped extends Component<DEPRECATED_RouteComponentProps> {
    @injectDependency(LoginStore)
    declare private loginStore: LoginStore;
    @injectDependency(CaptchaStore)
    declare private captchaStore: CaptchaStore;

    componentDidMount() {
        this.loginStore.form.validate();
        this.loginStore.initialize();
    }

    login = async () => {
        await this.loginStore.login();
    };

    redirectToResetPassword = () => {
        this.loginStore.updateLoginState(LoginState.ResetPasswordRequest);
    };

    onAnimationComplete = () => {};

    shouldDisableSubmit = () => {
        const { isLoading, isCaptchaRequired } = this.loginStore;
        return (
            this.loginStore.form.hasError ||
            isLoading ||
            (isCaptchaRequired && !this.captchaStore.isCaptchaVerified)
        );
    };

    render() {
        const {
            isLoading,
            areInputsErrored,
            onUsernameChange,
            onPasswordChange,
            isCaptchaRequired,
            throwError,
            loginState,
            isCaptchaVerificationEnabled,
            isTurnstileInteractive,
            markTurnstileInteractive,
        } = this.loginStore;

        const { username, password, shouldRemember, passwordVisbility } = this.loginStore.form.$;
        const redirectUrlToTokenServer = this.loginStore.getRedirectUrlToTokenServer('msentra');

        return (
            <Fragment>
                <div className="m-b-4">
                    <Transition
                        animation="fade left"
                        duration={800}
                        visible={loginState === undefined}
                        transitionOnMount
                        onComplete={this.onAnimationComplete}
                    >
                        <Headline className="m-b-0" size="xlarge">
                            Sign in
                        </Headline>
                    </Transition>
                    <Transition
                        animation="fade right"
                        duration={800}
                        ease="ease"
                        visible={loginState === undefined}
                        transitionOnMount
                    >
                        <Headline size="xlarge">to ServiceTitan</Headline>
                    </Transition>
                </div>
                <Transition
                    duration={800}
                    transitionOnMount
                    animation="fade down"
                    visible={loginState === undefined}
                >
                    <div className="st-login-view">
                        <Form onSubmit={this.login}>
                            <Form.Input
                                size="large"
                                name="username"
                                placeholder="Username"
                                onChange={onUsernameChange}
                                value={username.value}
                                error={areInputsErrored}
                            />
                            <PasswordInput
                                onChange={onPasswordChange}
                                value={password.value}
                                isPasswordVisible={passwordVisbility.value}
                                togglePasswordVisibility={
                                    passwordVisbility.DEPRECATED_onChangeHandler
                                }
                                className="m-b-2"
                                error={areInputsErrored}
                            />
                            <Form.Checkbox
                                className="m-b-0 p-b-3"
                                label="Remember me"
                                checked={shouldRemember.value}
                                onChange={shouldRemember.onChangeHandler}
                            />
                            <Turnstile
                                onBeforeInteractive={markTurnstileInteractive}
                                className={classnames('m-b-1', {
                                    'd-n': !isTurnstileInteractive,
                                })}
                                size="flexible"
                                theme="light"
                                appearance="interaction-only"
                                sitekey={TurnstileSiteKey}
                                refreshExpired="auto"
                            />
                            {isCaptchaVerificationEnabled && isCaptchaRequired && (
                                <Captcha
                                    forceShow={isCaptchaRequired}
                                    params={{ username: username.value }}
                                    onError={throwError}
                                />
                            )}
                            <Button
                                full
                                primary
                                className="m-t-1 m-b-2"
                                size="large"
                                type="submit"
                                disabled={this.shouldDisableSubmit()}
                                loading={isLoading}
                            >
                                Sign In
                            </Button>
                            {redirectUrlToTokenServer != null && (
                                <Button
                                    size="large"
                                    full
                                    fill="subtle"
                                    href={redirectUrlToTokenServer}
                                    className="m-b-2"
                                >
                                    {' '}
                                    Sign in with Microsoft Entra ID
                                </Button>
                            )}
                            <Button
                                primary
                                size="large"
                                full
                                fill="subtle"
                                onClick={this.redirectToResetPassword}
                                className={classnames('st-forgot-password m-b-2')}
                            >
                                Forgot password?
                            </Button>
                        </Form>
                    </div>
                </Transition>
            </Fragment>
        );
    }
}

export const LoginForm = DEPRECATED_withRouter(LoginFormUnwrapped);
